import { Button, InlineError, Input, Spinner } from 'avo-ui'
import TabToggle from 'components/commons/tab-toogle'
import UploadImage from 'components/commons/upload-image'
import { SUBMIT_TYPE } from 'constants/constant'
import TextEditor from 'components/commons/text-editor'

export const GiftCreate = ({
    sectionRef,
    giftDetail,
    onChangeForm,
    errorForm,
    isLoading,
    isLoadingUpload,
    isCreating,
    isUpdating,
    isDrafting,
    onSubmit,
}) => {
    return (
        <div ref={sectionRef} className={'flex flex-col space-y-3 px-9 py-4'}>
            {isLoading ? (
                <Spinner className={'w-8 h-8 my-10 mx-auto !border-blue-50'} />
            ) : (
                <>
                    <TabToggle
                        title={'Gift Info'}
                        content={
                            <div className={'flex space-x-16'}>
                                <div className={'flex-1 flex-col space-y-5'}>
                                    <div className={'flex flex-col space-y-3'}>
                                        <div className={'font-semibold text-blue-90 required'}>Nama Gift</div>
                                        <Input
                                            className={'flex-1'}
                                            name={'name'}
                                            placeholder={'Masukkan nama gift'}
                                            value={giftDetail?.name}
                                            onChange={onChangeForm}
                                        />
                                        <InlineError className='mt-2' message={errorForm?.name} />
                                    </div>
                                    <div className={'flex flex-col space-y-3'}>
                                        <div className={'font-semibold text-blue-90'}>Deskripsi</div>
                                        <div className={`flex-1 ${errorForm?.description ? 'space-y-12' : 'pb-10'}`}>
                                            <TextEditor
                                                defaultValue={giftDetail?.description || '<p></p>'}
                                                onChange={(value) => onChangeForm({ name: 'description', value })}
                                                placeholder={'Isi uraian deskripsi'}
                                            />
                                            <InlineError message={errorForm?.description} />
                                        </div>
                                    </div>
                                    <div className={'flex flex-col space-y-3'}>
                                        <div className={'font-semibold text-blue-90 required'}>Kode SKU</div>
                                        <Input
                                            className={'flex-1'}
                                            name={'sku'}
                                            placeholder={'Masukkan kode SKU'}
                                            value={giftDetail?.sku}
                                            onChange={onChangeForm}
                                        />
                                        <InlineError className='mt-2' message={errorForm?.sku} />
                                    </div>
                                    <div className={'flex flex-col space-y-3'}>
                                        <div className={'font-semibold text-blue-90 required'}>Stok</div>
                                        <Input
                                            type={'number'}
                                            className={'flex-1'}
                                            name={'stock_quantity'}
                                            placeholder={'Masukkan stok'}
                                            value={giftDetail?.stock_quantity}
                                            onChange={onChangeForm}
                                        />
                                        <InlineError className={'mt-2'} message={errorForm?.stock_quantity} />
                                    </div>
                                    <div className={'flex flex-col space-y-3'}>
                                        <div className={'font-semibold text-blue-90 required'}>Harga Gift</div>
                                        <Input
                                            type={'currency'}
                                            className={'flex-1'}
                                            name={'price'}
                                            addonBefore={'Rp'}
                                            placeholder={'Masukkan harga gift'}
                                            value={giftDetail?.price}
                                            onChange={onChangeForm}
                                        />
                                        <InlineError className={'mt-2'} message={errorForm?.price} />
                                    </div>
                                </div>
                                <div className={'flex-1 flex-col space-y-5'}>
                                    <div
                                        className={`flex flex-col ${(giftDetail?.image_url?.base64 || giftDetail?.image_url) && 'space-y-3'}`}
                                    >
                                        <div className={'font-semibold text-blue-90 required'}>Foto Gift</div>
                                        <UploadImage
                                            className={'w-fit'}
                                            classNameImage={'!w-48 !h-48 border border-neutral-30 rounded-md'}
                                            id={'image-gift'}
                                            value={giftDetail?.image_url?.base64 || giftDetail?.image_url}
                                            onChange={(value) => onChangeForm({ name: 'image_url', value })}
                                        />
                                        <InlineError className='mt-2' message={errorForm?.image_url} />
                                    </div>
                                    <div className={'flex flex-col space-y-3'}>
                                        <div className={'font-semibold text-blue-90'}>Alt Text</div>
                                        <Input
                                            className={'flex-1'}
                                            name={'image_alt_text'}
                                            placeholder={'Masukkan alt text'}
                                            value={giftDetail?.image_alt_text}
                                            onChange={onChangeForm}
                                        />
                                        <InlineError className='mt-2' message={errorForm?.image_alt_text} />
                                    </div>
                                    <div className={'flex flex-col space-y-3'}>
                                        <div className={'font-semibold text-blue-90 required'}>Berat (Gram)</div>
                                        <Input
                                            type={'number'}
                                            className={'flex-1'}
                                            name={'weight'}
                                            placeholder={'Masukkan berat'}
                                            value={giftDetail?.weight}
                                            onChange={onChangeForm}
                                        />
                                        <InlineError className={'mt-2'} message={errorForm?.weight} />
                                    </div>
                                    <div className={'flex flex-col space-y-3'}>
                                        <div className={'font-semibold text-blue-90'}>Dimensi (Tinggi)</div>
                                        <Input
                                            type={'number'}
                                            className={'flex-1'}
                                            name={'height'}
                                            placeholder={'Masukkan dimensi (tinggi)'}
                                            value={giftDetail?.height}
                                            onChange={onChangeForm}
                                        />
                                        <InlineError className={'mt-2'} message={errorForm?.height} />
                                    </div>
                                    <div className={'flex flex-col space-y-3'}>
                                        <div className={'font-semibold text-blue-90'}>Dimensi (Panjang)</div>
                                        <Input
                                            type={'number'}
                                            className={'flex-1'}
                                            name={'length'}
                                            placeholder={'Masukkan dimensi (panjang)'}
                                            value={giftDetail?.length}
                                            onChange={onChangeForm}
                                        />
                                        <InlineError className={'mt-2'} message={errorForm?.length} />
                                    </div>
                                    <div className={'flex flex-col space-y-3'}>
                                        <div className={'font-semibold text-blue-90'}>Dimensi (Lebar)</div>
                                        <Input
                                            type={'number'}
                                            className={'flex-1'}
                                            name={'width'}
                                            placeholder={'Masukkan dimensi (lebar)'}
                                            value={giftDetail?.width}
                                            onChange={onChangeForm}
                                        />
                                        <InlineError className={'mt-2'} message={errorForm?.width} />
                                    </div>
                                </div>
                            </div>
                        }
                    />
                    <div className={'flex py-3 space-x-3 justify-center'}>
                        <Button
                            className={'w-[200px]'}
                            type={'outline'}
                            title={'Draft'}
                            loading={isLoadingUpload || isDrafting}
                            onClick={() => onSubmit(SUBMIT_TYPE?.DRAFT)}
                        />
                        <Button
                            className={'w-[200px]'}
                            title={'Publish'}
                            loading={isLoadingUpload || isCreating || isUpdating}
                            onClick={() => onSubmit(SUBMIT_TYPE?.PUBLISH)}
                        />
                    </div>
                </>
            )}
        </div>
    )
}
